<template>
  <div style="padding: 0 10px 0 10px">
    <div style="margin-top: 20px">
      <el-form :inline="false" size="small" label-width="88" :data="info">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="订单状态：">{{ orderBaseInfo.orderState }}</el-form-item>
            <el-form-item label="关联改签订单号：">{{
              orderBaseInfo.relationalChangedOrderNo
            }}</el-form-item>
            <el-form-item label="订单来源：">{{ orderBaseInfo.orderResource }}</el-form-item>
            <el-form-item label="乘客备注：">{{ orderBaseInfo.passengerRemark }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系电话：">
              <div style="display: flex">
                <yd-link
                  v-if="userList.includes(orderBaseInfo.contactPhoneNumber)"
                  permi="user_center_manage"
                  :value="orderBaseInfo.contactPhoneNumber"
                  :url="phoneUrl(info, orderBaseInfo.contactPhoneNumber)"
                  :need="true"
                  type="userInfo"
                />
                <span v-else>{{ orderBaseInfo.contactPhoneNumber }}</span>
                <span style="padding-left: 10px" v-if="isOpenSet">
                  <el-button
                    type="primary"
                    size="small"
                    @click="handleOpenSet"
                    v-has-permi="['order_intercity_editPhone']"
                    >修改电话</el-button
                  >
                </span>
                <span style="padding-left: 10px" v-if="isShowSet">
                  <el-input
                    v-model="newMobile"
                    clearable
                    placeholder="请输入电话号码"
                    maxlength="11"
                    show-word-limit
                    style="width: 9vw; padding: 0 3px"
                  />
                  <el-button size="mini" @click="phoneCancel">取消</el-button>
                  <el-button type="success" size="mini" @click="submit">确定</el-button>
                </span>
              </div>
            </el-form-item>
            <el-form-item label="优惠券/活动名称:">{{
              orderBaseInfo.couponOrActivityName
            }}</el-form-item>
            <!-- <el-form-item label="云推官名称：">{{ orderBaseInfo.merchantName }}</el-form-item> -->
            <el-form-item label="后台备注：">
              <div style="display: flex">
                <sapn>{{ orderBaseInfo.backgroundRemark }}</sapn>
                <span v-if="isOpenRemark" style="padding-left: 10px">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="openBtn"
                    v-has-permi="['order_intercity_setRemark']"
                    >设置备注
                  </el-button>
                </span>
                <sapn style="padding-left: 10px" v-if="isShowRemark">
                  <el-input
                    type="textarea"
                    :rows="2"
                    v-model="newRemark"
                    placeholder="请输入备注"
                    style="width: 20vw"
                  />
                  <el-button size="mini" @click="remarkCancel">取消</el-button>
                  <el-button type="success" size="mini" @click="sumitRemark">确定</el-button>
                </sapn>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="下单人电话：">
              <yd-link
                v-if="userList.includes(orderBaseInfo.orderPhoneNumber)"
                permi="user_center_manage"
                :value="orderBaseInfo.orderPhoneNumber"
                :url="phoneUrl(info, orderBaseInfo.orderPhoneNumber)"
                :need="true"
                type="userInfo"
              />
              <span v-else>{{ orderBaseInfo.orderPhoneNumber }}</span>
            </el-form-item>
            <el-form-item label="抵扣金额：">{{ orderBaseInfo.deductionAmount }}</el-form-item>
            <!-- <el-form-item label="云推官手机号：">{{
              orderBaseInfo.merchantPhoneNumber
            }}</el-form-item> -->
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { setMbOrMk } from '@/api/intercityorder'
  import { phoneUrl } from './utils'

  export default {
    name: 'baseInfo',
    props: {
      info: {}
    },
    data() {
      return {
        active: 1,
        isShowSet: false,
        isOpenSet: true,
        newMobile: '',
        isOpenRemark: true,
        newRemark: ''
      }
    },
    computed: {
      orderBaseInfo() {
        const { orderBaseInfo } = this.info || {}
        return orderBaseInfo || {}
      },
      userList() {
        const { userMap } = this.info || {}
        return Object.keys(userMap || {}) || []
      },
      phoneUrl() {
        return phoneUrl
      }
    },
    methods: {
      openBtn() {
        this.isOpenRemark = false
        this.isShowRemark = true
      },
      remarkCancel() {
        this.isOpenRemark = true
        this.isShowRemark = false
      },
      sumitRemark() {
        if (!this.newRemark) {
          this.$message.warning('请输入备注')
          return
        }
        const pms = {
          id: this.info.customOrderDetailBossChangeInfo.orderId,
          mobilePhone: '',
          remarks: this.newRemark
        }
        setMbOrMk(pms).then((resp) => {
          if (resp.code === 0) this.$message.success('修改成功')
          this.$emit('refreshData')
          this.isOpenRemark = true
          this.isShowRemark = false
          this.newRemark = ''
        })
      },
      handleOpenSet() {
        this.isShowSet = true
        this.isOpenSet = false
      },
      phoneCancel() {
        this.isShowSet = false
        this.isOpenSet = true
        this.newMobile = ''
      },
      submit() {
        if (!this.newMobile) {
          this.$message.warning('请输入电话号码')
          return
        }
        const pms = {
          id: this.info.customOrderDetailBossChangeInfo.orderId,
          mobilePhone: this.newMobile,
          remarks: ''
        }
        setMbOrMk(pms).then((resp) => {
          if (resp.code === 0) this.$message.success('修改成功')
          // details(this.info.id).then(resp => {
          //   this.info = resp.data
          // })
          this.$emit('refreshData')
          this.isShowSet = false
          this.isOpenSet = true
          this.newMobile = ''
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .tipsBoxs {
    margin-left: 10px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #9f9f9f;
  }

  .tipsBoxs span {
    margin-left: 5px;
  }

  .pdding {
    padding: 10px 20px 0 20px;
  }

  .mt-20 {
    margin-top: 20px;
    margin-right: 10px;
  }
  .el-form-item--small.el-form-item {
    margin-bottom: 2px;
  }

  ::v-deep .el-step__title {
    font-size: 12px;
    line-height: 30px;
  }

  ::v-deep .el-step__description {
    padding: 0 !important;
    margin-top: -4px;
    font-size: 8px;
    line-height: 20px;
    font-weight: 400;
    width: 76px;
  }
</style>
